import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver/FileSaver';
import { UserService } from '../../../../services/user.service';
import { ReportService } from '../../../../services/report.service';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-swk-government',
  templateUrl: './swk-government.component.html',
  styleUrls: ['./swk-government.component.css']
})
export class CommonReportsSwkGovernmentComponent implements OnInit, OnDestroy {
  swkcommonreportform: FormGroup;
  allSub: Subscription[] = [];
  errorMessage: string = '';
  downloadMessage: string = '';
  loading: boolean = false;
  userName: string = '';
  screenCode: string = '';
  isSubmit: boolean = false;
  enableInvoiceDate: boolean = false;
  airlineAgencyCodes = [];
  accountOfficeCodes = [];
  sortedBy = [
    { value: 'Acc_Acc_No', viewValue: 'Pukal Number' },
    { value: 'Acc_Acc_Off_Code', viewValue: 'Kod PTJ' },
    { value: 'Bill_Agency_Code', viewValue: 'Travel Agent Code' },
    { value: 'Acc_Airline_Agency_Code', viewValue: 'Airline Agency Code' },
    { value: 'Bill_Booking_Dt', viewValue: 'Booking Date' },
    { value: 'Bill_Pnr', viewValue: 'PNR' },
    { value: 'Bill_Pymnt_Dt', viewValue: 'Payment Date' },
    { value: 'Bill_Pymnt_Type', viewValue: 'Payment Type' }
  ];
  orderBy = [
    { value: 'ASC', viewValue: 'Ascending' },
    { value: 'DESC', viewValue: 'Descending' }
  ];
  fileType = [
    { value: '.pdf', viewValue: 'PDF File' },
    { value: '.xls', viewValue: 'Excel File' }
  ];

  constructor(private userService: UserService,
    private reportService: ReportService,
    public snackBar: MatSnackBar) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;
  }

  ngOnInit() {
    this.swkcommonreportform = new FormGroup({
      airlineAgencyCode: new FormControl({ value: '', disabled: false }),
      accountOfficeCode: new FormControl({ value: '', disabled: false }),
      pukalNumber: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      travelagent: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      agencyCode: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      ptjCode: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      pnr: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      paymentType: new FormControl({ value: '', disabled: false }, [Validators.maxLength(32767)]),
      bookingDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      bookingDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      paymentDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      paymentDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      invoiceDateFrom: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      invoiceDateTo: new FormControl({ value: new Date, disabled: false }, [Validators.required]),
      commonReportSortBy: new FormControl({ value: new Date, disabled: false }),
      commonReportOrderBy: new FormControl({ value: new Date, disabled: false }),
      exportedFileType: new FormControl({ value: new Date, disabled: false })
    });

    this.loading = true;

    let initial_sub = this.reportService.getInitSwkCommonReports()
      .subscribe(
        (data) => {
          this.loading = false;
          if (data.status === 204) {

          } else if (data.status === 200) {
            this.airlineAgencyCodes = data.body['agentCodes'];
            this.accountOfficeCodes = data.body['accountOffices'];

            this.swkcommonreportform.setValue({
              airlineAgencyCode: this.airlineAgencyCodes[0].Airline_Agency_Code,
              accountOfficeCode: this.swkcommonreportform.get('accountOfficeCode')!.value,
              pukalNumber: this.swkcommonreportform.get('pukalNumber')!.value,
              travelagent: this.swkcommonreportform.get('travelagent')!.value,
              agencyCode: this.swkcommonreportform.get('agencyCode')!.value,
              ptjCode: this.swkcommonreportform.get('ptjCode')!.value,
              pnr: this.swkcommonreportform.get('pnr')!.value,
              paymentType: this.swkcommonreportform.get('paymentType')!.value,
              bookingDateFrom: this.swkcommonreportform.get('bookingDateFrom')!.value,
              bookingDateTo: this.swkcommonreportform.get('bookingDateTo')!.value,
              paymentDateFrom: this.swkcommonreportform.get('paymentDateFrom')!.value,
              paymentDateTo: this.swkcommonreportform.get('paymentDateTo')!.value,
              invoiceDateFrom: this.swkcommonreportform.get('invoiceDateFrom')!.value,
              invoiceDateTo: this.swkcommonreportform.get('invoiceDateTo')!.value,
              commonReportSortBy: this.sortedBy[0].value,
              commonReportOrderBy: this.orderBy[0].value,
              exportedFileType: this.fileType[0].value
            });
          } else {
            this.openSnackBar('Error loading agency and account office.', '');
          }
        },
        (error) => {
          this.loading = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(initial_sub);
  }

  onSubmit(form: FormGroup) {
    this.isSubmit = true;
    this.downloadMessage = 'System is generating report....';

    let DownloadCommonReport = {
      PukalNumber: this.swkcommonreportform.get('pukalNumber')!.value,
      AccountOfficeCode: this.swkcommonreportform.get('accountOfficeCode')!.value,
      TravelAgent: this.swkcommonreportform.get('travelagent')!.value,
      AgencyCode: this.swkcommonreportform.get('agencyCode')!.value,
      AirlineAgencyCode: this.swkcommonreportform.get('airlineAgencyCode')!.value,
      ptjCode: this.swkcommonreportform.get('ptjCode')!.value,
      Pnr: this.swkcommonreportform.get('pnr')!.value,
      PaymentType: this.swkcommonreportform.get('paymentType')!.value,
      BookingDateFrom: this.swkcommonreportform.get('bookingDateFrom')!.value,
      BookingDateTo: this.swkcommonreportform.get('bookingDateTo')!.value,
      PaymentDateFrom: this.swkcommonreportform.get('paymentDateFrom')!.value,
      PaymentDateTo: this.swkcommonreportform.get('paymentDateTo')!.value,
      InvoiceDateFrom: this.swkcommonreportform.get('invoiceDateFrom')!.value,
      InvoiceDateTo: this.swkcommonreportform.get('invoiceDateTo')!.value,
      SortBy: this.swkcommonreportform.get('commonReportSortBy')!.value,
      OrderBy: this.swkcommonreportform.get('commonReportOrderBy')!.value,
      FileType: this.swkcommonreportform.get('exportedFileType')!.value
    }

    let save_sub = this.reportService.downloadSwkCommonReports(DownloadCommonReport)
      .subscribe(
        (value) => {
          if (value.status === 204) {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          } else if (value.status === 200) {
            if (DownloadCommonReport.FileType === '.xls') {
              let blob = new Blob([value.body], { type: 'application/vnd.ms-excel' });
              saveAs(blob, 'SWK CommonReport.xls');
              this.openSnackBar('Report Created.', '');
              this.isSubmit = false;
            } else if (DownloadCommonReport.FileType === '.pdf') {
              let blob = new Blob([value.body], { type: 'application/pdf' });
              saveAs(blob, 'SWK CommonReport.pdf');
              this.openSnackBar('Report Created.', '');
              this.isSubmit = false;
            }
          } else {
            this.isSubmit = false;
            this.openSnackBar('Download failed.', '');
          }
        },
        (error) => {
          this.errorMessage = <any>error;
          this.isSubmit = false;
          this.openSnackBar(this.errorMessage, '');
        });

    //Adds into array for each subscribe
    this.allSub.push(save_sub);
  }

  cbOnChange(e): void {
    this.enableInvoiceDate = e.checked;
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
